export function slugifyCategoryName(name = "") {
  return String(name)
    .trim()
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function getCategorySlug(category = {}) {
  return slugifyCategoryName(category.categoryName || category.name || category.id);
}
